import React from 'react'
import {Button, Card, CardBody, Col, Form, FormGroup, Input, Row} from "reactstrap";
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../translations/resource_translations";
import {common_strings} from "../../translations/common_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import stringHelpers from "../../helpers/StringHelper";
import businessApiService from "../../api/business-api-service";

let resourceStrings = new LocalizedStrings(resource_strings);
let commonStrings = new LocalizedStrings(common_strings);

const propTypes = {};

class RequiredFieldsView extends React.Component {
    handleChange = this.handleChange.bind(this);

    constructor(props) {
        super(props);
        this.state = {
            termsLink: props.terms_link,
            reqFields: props.required_fields
        };
    }

    handleChange(event) {

        let newValue = event.target.value;
        let targetId = event.target.id;
        let checkBoxValue = event.target.checked;

        switch (targetId) {
            case "input-terms-link":
                this.setState({
                    termsLink: newValue
                });
                break;
            case "input-phone-cb":
                this.handleCBClick(checkBoxValue, "phone")
                break;
            case "input-address-cb":
                this.handleCBClick(checkBoxValue, "address")
                break;
            case "input-dni-cb":
                this.handleCBClick(checkBoxValue, "dni")
                break;
            default:
                return
        }
    }

    handleCBClick(isOn, fieldName) {
        let currentValue = this.state.reqFields

        if (isOn) {
            if (!currentValue.includes(fieldName)) {
                currentValue.push(fieldName)
            }
        }
        else {
            const index = currentValue.indexOf(fieldName);
            if (index > -1) {
                currentValue.splice(index, 1);
            }
        }

        this.setState({reqFields: currentValue})
    };

    updateReqFields(e) {
        e.preventDefault();

        const cp_data = {
          required_fields: this.state.reqFields.join(","),
          terms_link: this.state.termsLink
        };

        businessApiService.updateReqFields(cp_data)
            .then(res => {
                this.props.closeReqFieldsView()
            })
            .catch((e) => {
                this.props.handleError(e)
            });
    }

    render() {
        this.localize();

        return (
            <Card className="bg-secondary shadow">
                <CardBody>
                    <Form onSubmit={this.handleSubmit}>
                        <div className="pl-lg-4">
                            <h5>
                                {resourceStrings.public_profile.required_info_expl}
                            </h5>

                            <Row className="mt-2">
                                <Col lg="12">
                                    <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                                        <input
                                            className="custom-control-input"
                                            id="input-name-cb"
                                            onChange={this.handleChange}
                                            checked={true}
                                            disabled={true}
                                            type="checkbox"
                                        />
                                        <label className="custom-control-label" htmlFor="input-name-cb">
                                            {commonStrings.name}
                                        </label>
                                    </div>
                                </Col>
                            </Row>

                            <Row className="mt-2">
                                <Col lg="12">
                                    <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                                        <input
                                            className="custom-control-input"
                                            id="input-email-cb"
                                            onChange={this.handleChange}
                                            checked={true}
                                            disabled={true}
                                            type="checkbox"
                                        />
                                        <label className="custom-control-label" htmlFor="input-email-cb">
                                            {commonStrings.email}
                                        </label>
                                    </div>
                                </Col>
                            </Row>

                            <Row className="mt-2">
                                <Col lg="12">
                                    <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                                        <input
                                            className="custom-control-input"
                                            id="input-phone-cb"
                                            onChange={this.handleChange}
                                            checked={this.state.reqFields.includes("phone")}
                                            type="checkbox"
                                        />
                                        <label className="custom-control-label" htmlFor="input-phone-cb">
                                            {commonStrings.phone}
                                        </label>
                                    </div>
                                </Col>
                            </Row>

                            <Row className="mt-2">
                                <Col lg="12">
                                    <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                                        <input
                                            className="custom-control-input"
                                            id="input-address-cb"
                                            onChange={this.handleChange}
                                            checked={this.state.reqFields.includes("address")}
                                            type="checkbox"
                                        />
                                        <label className="custom-control-label" htmlFor="input-address-cb">
                                            {commonStrings.address}
                                        </label>
                                    </div>
                                </Col>
                            </Row>

                            <Row className="mt-2">
                                <Col lg="12">
                                    <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                                        <input
                                            className="custom-control-input"
                                            id="input-dni-cb"
                                            onChange={this.handleChange}
                                            checked={this.state.reqFields.includes("dni")}
                                            type="checkbox"
                                        />
                                        <label className="custom-control-label" htmlFor="input-dni-cb">
                                            {commonStrings.id_number}
                                        </label>
                                    </div>
                                </Col>
                            </Row>

                            <Row className="mt-5">
                                <Col lg="12">
                                    <FormGroup style={{verticalAlign: 'center='}}>
                                        <label
                                            className="form-control-label"
                                        >
                                            {resourceStrings.public_profile.term_link}
                                        </label>
                                        <Input
                                            placeholder="https://www.termsandconditions.com"
                                            className={this.termsLinkIdValid() == true ? "form-control-alternative" : "is-invalid"}
                                            onChange={this.handleChange}
                                            value={this.state.termsLink || ""}
                                            id="input-terms-link"
                                            type="text"
                                        />

                                        <div>
                                            <small>{resourceStrings.public_profile.term_link_expl}</small>
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <hr className="my-4"/>
                        </div>

                        <Row>
                            <Col lg="12">
                                <Col className="text-right">
                                    <Button
                                        color="warning"
                                        outline="button"
                                        size="lg"
                                        onClick={e => this.props.closeReqFieldsView(e)}
                                    >
                                        {commonStrings.close}
                                    </Button>

                                    <Button
                                        color="default"
                                        size="lg"
                                        onClick={e => this.updateReqFields(e)}
                                    >
                                        {commonStrings.save}
                                    </Button>
                                </Col>
                            </Col>
                        </Row>

                    </Form>
                </CardBody>
            </Card>
        )
    }

    termsLinkIdValid() {
      return !this.state.termsLink || this.state.termsLink.length == 0 || this.state.termsLink.toLowerCase().includes("https")
    };

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }
}

RequiredFieldsView.propTypes = propTypes;

export default RequiredFieldsView;